<template>
  <!-- Shared E2M OnAir Meet launch chooser. Used by ExpoView2 (e2o) and MyMeetings (o2o).
       v-model controls visibility; emits `pick(useDesktop)` and `cancel`. -->
  <v-dialog
    :value="value"
    @input="$emit('input', $event)"
    max-width="460"
    persistent
  >
    <v-card class="pa-4">
      <v-card-title class="pa-2 d-flex align-center">
        Join meeting
        <v-spacer />
        <v-btn icon small @click="$emit('cancel')" aria-label="Cancel joining">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pb-0">
        Open this meeting in the E2M OnAir Meet desktop app for the best
        experience, or continue in this browser.
      </v-card-text>
      <v-card-actions class="px-2 pt-4">
        <v-spacer />
        <v-btn text @click="$emit('pick', false)">Continue On This Browser</v-btn>
        <v-btn color="#EA212D" dark @click="$emit('pick', true)"
          >Open E2M OnAir Meet</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "E2MOnAirMeetJoinDialog",
  props: {
    value: { type: Boolean, default: false },
  },
};
</script>
